import { useAppSelector } from '@pkg/hooks';

import { type Competition } from '@app/client/common/structs';

export function useGetWishlistDataFromCurrentGame(currentGame?: Competition) {
    const userId = useAppSelector((s) => s.user.userAccount?.user.id);
    const gameWishlists = currentGame?.wishlists;
    const userWishlists = gameWishlists?.find((wl) => wl?.user_id === userId);

    return { gameWishlists, userWishlists };
}
